/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Guide_Worth_BodyInputs */

const en_fw_guide_worth_body = /** @type {(inputs: Fw_Guide_Worth_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firefly Wedding mixes a sweeping romance with real danger: an assassin who has never failed, a heroine who is running out of time, and a Meiji world that cares little for either. The manga took first place in the 2024 Nationwide Bookstore Employees’ Recommended Comics and won the NTT Solmare Digital Comic Awards grand prize, and early reviews of the Firefly Wedding anime describe its premiere as gruesome and addictive. If you like slow-burn love stories with an edge, it belongs on your list.`)
};

const zh_fw_guide_worth_body = /** @type {(inputs: Fw_Guide_Worth_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`萤火之嫁把宏大的爱情与真切的危险揉在一起：从未失手的杀手、时日无多的女主角，以及对两人都不留情面的明治社会。原作曾获 2024 年全国书店员推荐漫画第一名与 NTT Solmare 数字漫画大奖大奖，动画首播也被评论形容为“残酷又令人上瘾”。喜欢带锋芒的慢热爱情故事，就别错过它。`)
};

/**
* | output |
* | --- |
* | "Firefly Wedding mixes a sweeping romance with real danger: an assassin who has never failed, a heroine who is running out of time, and a Meiji world that car..." |
*
* @param {Fw_Guide_Worth_BodyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const fw_guide_worth_body = /** @type {((inputs?: Fw_Guide_Worth_BodyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Guide_Worth_BodyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fw_guide_worth_body(inputs)
	return zh_fw_guide_worth_body(inputs)
});
export { fw_guide_worth_body as "fw.guide.worth.body" }